import api from '../apiService';

export const logout = async () => {
  try {
    await api.post('/logout');
  } finally {
    localStorage.removeItem('token');
    // Optionally clear other auth-related data
  }
};

export const signup = (data) => api.post('/signup', data);

export const login = async (data) => {
  const formData = new URLSearchParams();
  formData.append('username', data.email);
  formData.append('password', data.password);
  
  const response = await api.post('/login', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });

  if (response.data.access_token) {
    // Ensure token is stored with Bearer prefix
    localStorage.setItem('token', `Bearer ${response.data.access_token}`);
  }

  return response;
};

export const getUserEmailFromToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      // console.log('No token found in localStorage');
      return null;
    }

    const parts = token.split('.');
    if (parts.length !== 3) {
      // console.log('Invalid token format');
      return null;
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(window.atob(base64));

    // Check for common JWT email field names
    const email = payload.email || payload.sub || payload.username;
    
    if (!email) {
      console.log('No email found in token payload:', payload);
      return null;
    }

    return email;
  } catch (error) {
    // console.error('Error parsing token:', error);
    return null;
  }
};

export const getCurrentUserDetails = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await api.get('/get-current-user-details', {
      headers: {
        'Authorization': token
      }
    });

    if (!response.data) {
      throw new Error('Invalid response from server');
    }

    return response.data;
  } catch (error) {
    // console.error('Error fetching user details:', error);
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
    }
    throw error;
  }
};